import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import "./trainingQuiz.scss";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { PlusCircleFill } from "react-bootstrap-icons";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { Modal } from "react-bootstrap";
import { postDetails, postMultipartDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton/CustomButton";
import InputField from "../../components/InputField/InputField";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import CroppingModal from "../../components/Cropping Modal/CroppingModal";
import encrypt from "../../utils/helpers/encrypt";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import convertTimestamp from "../../utils/helpers/convertTimeStamp";

interface QuizFolder{
  id: number;
  created: Date;
  modified: Date;
  quizCount: number;
  is_delete: 0|1;
  folder_name: string;
  folderImg: string;
  folderOrgImg: string;
  training_id: number;
  is_active: 0|1;
  isTrainingQuiz: 0|1;
  show_result: 0|1;
  show_icon: boolean;
  status?: 0|1;
}

const TrainingQuiz: React.FunctionComponent = () => {
 const navigate = useNavigate();
  const cmpMounted = useRef(false);
  const [showModal, setShowModal] = useState(false);
  const [showCroppingModal, setShowCroppingModal] = useState(false);
  const [quizFolders, setQuizFolders] = useState<QuizFolder[]>([]);
  
  const [folderName, setFolderName] = useState("");
  const [folderImg, setFolderImg] = useState<{ value: any; src: string }>({
    value: null,
    src: "",
  });
  const [closeDate, setCloseDate] = useState<Date | null>(new Date());
  const [lengthRemaining, setLengthRemaining] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentItemId, setCurrentItemId] = useState<number | null>(null);
  const dispatch = useAppDispatch();
 
  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchQuiz();
  }, []);

  const fetchQuiz = async () => {
    try{
      dispatch(showLoader('Loading data...'));
    const response = await postDetails(APIList.GET_ALL_TRAINING_QUIZ_FOLDER, {});
    const transformedData = response.data
    .filter((item: QuizFolder) => item.isTrainingQuiz === 1) 
    .map((item: QuizFolder) => ({
      ...item,
      status: item.is_active,
      created:convertTimestamp(item.created)
    }));
    console.log(transformedData)
    setQuizFolders(transformedData)
  } catch (error) {
    console.log("Error fetching training quiz data:", error)
  }
  finally {
    dispatch(hideLoader())
  }
  };

  const handleShowModal = () => {
    setFolderName("");
    setFolderImg({ value: null, src: "" });
    setCloseDate(null);
    setIsEditing(false);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false)

  const handleFolderNameChange = (ev: any) => {
    setFolderName(ev.target.value);
    if (ev.target.value === "") {
      setLengthRemaining(0)
    } else {
      setLengthRemaining(50 - ev.target.value.length)
    }
  };

  const handleCoverImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFolderImg({
        value: e.target.files[0],
        src: URL.createObjectURL(e.target.files[0]),
      });
      setShowCroppingModal(true);
    }
  };

  const handleCrop = (croppedImage: string) => {
    setFolderImg((prev) => ({ ...prev, src: croppedImage }));
    setShowCroppingModal(false);
  };

  const removeImage = () => {
    setFolderImg({ value: null, src: "" });
  };


  const handleCheckboxChange = (ev:any) => {
    setIsChecked(ev.target.checked);
  };

  const handleCloseDateChange = (date: Date | null) => {
    setCloseDate(date)
  };

  const editItem = (item: any) => {
    setFolderName(item.folder_name);
    setFolderImg({ value: null, src: item.folderImg });
    setCloseDate(new Date(item.closeDate === undefined ? new Date(): item.closeDate));
    setIsChecked(Boolean(item.isTrainingQuiz));
    setLengthRemaining(50-item.folder_name.length);
    setIsEditing(true);
    setCurrentItemId(item.id);
   setShowModal(true)
  };

  const handleSubmit = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault()
    if (!folderName || !closeDate) {
      alert("Please fill in all fields.");
      return;
    }

    const formattedCloseDate = closeDate?.toISOString();
    const formData = new FormData();
    if (folderImg.value) {
      formData.append("folderImg", folderImg.value);
    } else {
      formData.append("folderImg", folderImg.src || "");
    }


    try {
      let response;

      if (isEditing && currentItemId !== null) {

        
    formData.append(
      "data",
      encrypt({
        id: currentItemId,
        folder_name: folderName,
        closeDate: formattedCloseDate,
        isTrainingQuiz: isChecked ? 1 : 0,
      })
    );

        response = await postMultipartDetails(
          APIList.ADD_TRAINING_QUIZ_FOLDER,
          formData
        );
        console.log()

      } else {

        formData.append(
          "data",
          encrypt({
            folder_name: folderName,
            closeDate: formattedCloseDate,
            isTrainingQuiz: isChecked ? 1 : 0,
          })
    );

        response = await postMultipartDetails(
          APIList.ADD_TRAINING_QUIZ_FOLDER,
          formData
        );
      }

      if(response.status === "Failed" || response.Status === "Failed"){
        alert("Cannot add quiz folder")
        return
      }

      console.log("Response:", response);
    console.log(folderName)
    console.log(folderImg.src)
    console.log(isChecked)
    console.log(closeDate)
    setFolderName("")
    setFolderImg({
      value: null,
      src: "",
    })
    setIsChecked(false)
    setLengthRemaining(0)
    setCurrentItemId(null)
    setIsEditing(false)
    navigate(0)
  } catch (error) {
    console.error("Error submitting details:", error);
  }
    handleCloseModal()
  };

  const handleViewQuiz = (item:QuizFolder)=>{
    navigate(`/training-quiz/quizByFolder/${item.id}`)
  }
  

    const columns: TableColumn[] = [
        { key: "created", label: "Created", sortable: true , dataType:"string"},
        { key: "folder_name", label: "Folder Name", sortable: true, dataType:"string" },
        { key: "folderImg", label: "Folder Image", render: (item) =>{
          if(item.folderImg !== "" && item.folderImg !== null){
           return (
             <img src={item.folderImg} alt="Quiz Folder Image" width={50} />
           )
          }}
        },
        { key: "quizCount", label: `Quiz Count`, dataType:"button", button: {
          label: "View Quiz",
          onClick: handleViewQuiz
        } },
        { key: "trainingName", label: "Training Name" ,sortable: true, dataType:"string"},
        { key: "show_result", label: "Show Result", dataType: "toggle" },
      ];

    const deleteItemById = async (item:QuizFolder)=>{
      const response = await postDetails(APIList.DELETE_TRAINING_QUIZ_FOLDER, {id: item.id})
      console.log(response);
    if(response.status === "Failed"){
      alert("Cannot delete Quiz Folder");
      return
    }
    dispatch(showToast("Quiz Folder Deleted Succesfully."));
    setTimeout(() => dispatch(hideToast()), 3000);
       fetchQuiz()
    }  

    const handleStatusToggle = async (item: QuizFolder)=>{
      try {
      const response = await postDetails(APIList.TOGGLE_TRAINING_QUIZ_FOLDER_STATUS, {
        id: item.id,
        is_active: item.is_active === 0 ? 1: 0,
      });
      if(response.status === "Failed"){
        alert("Cannot update quiz folder status");
        return
      }

       setQuizFolders((prevData) => prevData.map((row: QuizFolder) => 
        row.id === item.id ? { ...row, status: row.status === 0 ? 1 : 0 } : row
      ))
      dispatch(showToast("Active Status Successfully Updated."));
        setTimeout(() => dispatch(hideToast()), 3000);
        fetchQuiz()

    } catch (error) {
      console.error("Error updating result:", error);
    }
    }  

    const toggleShowResultResult = async (item: QuizFolder) => {
      try {
        const newToggle = item.show_result === 1 ? 0 : 1;
        const response = await postDetails(APIList.TOGGLE_TRAINING_QUIZ_FOLDER_SHOW_RESULT, {
          id: item.id,
          show_result: newToggle,
        });
  
        if (response.status === "Failed") {
          console.log("Cannot update quiz folder show result status");
          return;
        }
  
        setQuizFolders((prevData) =>
          prevData.map((row) =>
            row.id === item.id ? { ...row, show_result: newToggle } : row
          )
        );
        dispatch(showToast("Show Result Status Successfully Updated."));
        setTimeout(() => dispatch(hideToast()), 3000);
        fetchQuiz()

      } catch (error) {
        console.error("Error updating result:", error);
      }
    }
  
 
  const handleAddQuiz = () => {
    navigate("/training-quiz/addQuiz");
  };

  const buttons = [
    {
      label: "Add Quiz Folder",
      theme: "danger",
      icon: <PlusCircleFill />,
      onClick: handleShowModal,
    },
    {
      label: "Add Quiz",
      theme: "danger",
      icon: <PlusCircleFill />,
      onClick: handleAddQuiz,
    },
  ];



  return (
    <LayoutContainer title="Quiz Folder">
    <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Quiz Folder
        </h2>
        {/* <PageHeader buttons={buttons} /> */}
      </div>
    <div className="mx-2">
    <CommonTable<QuizFolder>
     data={quizFolders} 
     columns={columns}
     onEdit={editItem}
     onDelete={deleteItemById}
     onStatusToggle={handleStatusToggle}
     onToggle={toggleShowResultResult}
    pagination={true}
    rowsPerPage={10}
    actions={{
      view: false,
      edit: true,
      delete: true,
      checkbox: false,
      status: true,
      showModal: false
    }} 
   /> 
    <div>
         <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? "Update Details" : "Add Quiz Folder"}</Modal.Title>{" "}
        </Modal.Header>
        <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <InputField
              name="folder_name"
              label="Folder Name"
              type="text"
              value={folderName}
              minLength={1}
              maxLength={50}
              required={true}
              onChangeInput={handleFolderNameChange}
            />
            <div className="font-12 text-end">{lengthRemaining}/50</div>
          </div>
          <div className="d-flex justify-content-between gap-4 mb-4">
            <div className="w-100">
              <div className="upload-quiz">
                <div className="font-12 mb-2 d-flex justify-content-between">
                  <span>Folder Image:</span>
                  <span>Size 1040x600px</span>
                </div>
                <label htmlFor="folder_image" className="w-100">
                  <div className="d-flex justify-content-between quiz-file-input">
                    <span className="font-12 choose-file-btn">Choose File</span>
                    <span className="font-12  browse-btn">Browse</span>
                  </div>
                </label>
              </div>
              <InputField
                type="file"
                name="folder_image"
                id="folder_image"
                value={""}
                className="d-none"
                onChangeInput={handleCoverImageChange}
              />
              <div className="font-12 text-danger text-end">
                (Format Support jpg, jpeg, png)
              </div>
            </div>

            <div className="display-image d-flex align-items-center justify-content-center font-12">
              {folderImg.src === "" ? (
                "Display Image"
              ) : (
                <img src={folderImg.src} alt="Quiz Image" width={138} height={80} />
              )}
            </div>
          </div>
          <div className="mb-4">
            <span className="d-flex gap-1">
              <input type="checkbox" 
              name="isTraining"
              id="isTraining"
              checked={isChecked}
              onChange={handleCheckboxChange}
               />
              <label htmlFor="isTraining" className=" font-12">
                <span>Is Training Quiz?</span>
              </label>
            </span>
          </div>
          <div className="mb-4">
          <CustomDatePicker
            label="Close Date"
            name="closeDate"
            required={true}
            placeholderText={"Select Close Date"}
            dateFormat={"dd-MM-yyyy"}
            onChange={handleCloseDateChange}
            defaultDate={closeDate}
          />
          </div>
          <CustomButton
            type="submit"
            size="md"
            theme="yellow"
          >
            Submit
          </CustomButton>
        </form>
      
        </Modal.Body>
        </Modal>
      {/* Cropping Modal */}
      {folderImg.value && (
        <CroppingModal
          show={showCroppingModal}
          handleClose={() => setShowCroppingModal(false)}
          image={folderImg.src}
          onCrop={handleCrop}
        />
      )}
      </div>
      </div>
    </LayoutContainer>
  );
};

export default TrainingQuiz;
